import EmailPreferencesApp from './app/app';
import ReactDOM from 'react-dom';
import React from 'react';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('react-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <EmailPreferencesApp />
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {};